export default {
  type: null,
  metric: null
}
